import React from "react";
import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, Instagram, Facebook } from "lucide-react";
import { business } from "../data/site";

export default function Footer() {
  const year = new Date().getFullYear();
  const { address, phone, phoneHref, emails, socials, google } = business;

  return (
    <footer className="bg-charcoal text-ivory mt-24" data-testid="site-footer">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 py-16 grid gap-12 md:grid-cols-4">
        <div className="md:col-span-2">
          <div className="font-serif text-2xl mb-3">Vinařství Brychta</div>
          <p className="text-ivory/70 max-w-md leading-relaxed">
            Rodinné vinařství, ubytování a autentické zážitky u vína v Charvátské Nové Vsi,
            kousek od Lednice a Valtic.
          </p>
          <div className="mt-6 flex items-center gap-4">
            {socials.instagram && (
              <a href={socials.instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="text-ivory/70 hover:text-gold">
                <Instagram size={20} />
              </a>
            )}
            {socials.facebook && (
              <a href={socials.facebook} target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="text-ivory/70 hover:text-gold">
                <Facebook size={20} />
              </a>
            )}
          </div>
        </div>

        <div>
          <div className="text-[11px] tracking-[.25em] uppercase text-gold mb-3">Navigace</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/zazitky" className="hover:text-gold">Zážitky</Link></li>
            <li><Link to="/ubytovani" className="hover:text-gold">Ubytování</Link></li>
            <li><Link to="/vina" className="hover:text-gold">Naše vína</Link></li>
            <li><Link to="/darkovy-poukaz" className="hover:text-gold">Dárkový poukaz</Link></li>
            <li><Link to="/kontakt" className="hover:text-gold">Kontakt</Link></li>
          </ul>
          <div className="text-[11px] tracking-[.25em] uppercase text-gold mt-6 mb-3">Právní informace</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/obchodni-podminky" className="hover:text-gold">Obchodní podmínky</Link></li>
            <li><Link to="/ochrana-osobnich-udaju" className="hover:text-gold">Ochrana osobních údajů</Link></li>
            <li><Link to="/cookies" className="hover:text-gold">Cookies</Link></li>
            <li><Link to="/provozovatele" className="hover:text-gold">Provozovatelé</Link></li>
          </ul>
        </div>

        <div>
          <div className="text-[11px] tracking-[.25em] uppercase text-gold mb-3">Kontakt</div>
          <ul className="space-y-3 text-sm text-ivory/85">
            <li className="flex gap-3">
              <MapPin size={16} className="mt-0.5 text-gold shrink-0" />
              <span>{address.street}<br />{address.postal} {address.city}<br />{address.country}</span>
            </li>
            <li className="flex gap-3">
              <Phone size={16} className="mt-0.5 text-gold shrink-0" />
              <a href={`tel:${phoneHref}`} data-testid="footer-phone" className="hover:text-gold">{phone}</a>
            </li>
            <li className="flex gap-3">
              <Mail size={16} className="mt-0.5 text-gold shrink-0" />
              <span>
                <span className="block text-ivory/60 text-[11px] uppercase tracking-wider">Vinařství</span>
                <a href={`mailto:${emails.winery}`} data-testid="footer-email-winery" className="hover:text-gold">{emails.winery}</a>
              </span>
            </li>
            <li className="flex gap-3">
              <Mail size={16} className="mt-0.5 text-gold shrink-0" />
              <span>
                <span className="block text-ivory/60 text-[11px] uppercase tracking-wider">Ubytování</span>
                <a href={`mailto:${emails.accommodation}`} data-testid="footer-email-accom" className="hover:text-gold">{emails.accommodation}</a>
              </span>
            </li>
            <li>
              <a href={google.profileUrl} target="_blank" rel="noopener noreferrer" className="inline-block mt-2 text-gold hover:text-ivory underline underline-offset-4">
                Zobrazit na Google Mapách
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-ivory/10">
        <div className="max-w-[1400px] mx-auto px-5 md:px-10 py-6 flex flex-col md:flex-row justify-between gap-3 text-xs text-ivory/50">
          <div>© {year} Vinařství Brychta &middot; Ubytování u vinaře</div>
          <div className="font-serif italic">„Přijeďte na chvíli zpomalit."</div>
        </div>
      </div>
    </footer>
  );
}
